import Select, { CSSObjectWithLabel } from 'react-select';
import MaterialIcon from './icon/MaterialIcon';
import { StateManagerProps } from 'react-select/dist/declarations/src/stateManager';
import theme from '@/styles/theme';

interface CustomStyles {
  selectStyle?: CSSObjectWithLabel;
  singleValue?: CSSObjectWithLabel;
  input?: CSSObjectWithLabel;
  indicatorSeparator?: CSSObjectWithLabel;
  valueContainer?: CSSObjectWithLabel;
  option?: CSSObjectWithLabel;
}
interface Props extends StateManagerProps {
  customStyles?: CustomStyles;
}

const SelectBox = ({ customStyles, ...props }: Props) => {
  return (
    <Select
      {...props}
      isSearchable={false}
      styles={{
        control: () => ({
          display: 'flex',
          width: '100%',
          border: `1px solid ${theme.DF_COLOR.GRAY100}`,
          background: theme.DF_COLOR.WHITE,
          borderRadius: 4,
          fontSize: 17,
          padding: '14px 16px',
          ...customStyles?.selectStyle
        }),
        singleValue: base => ({
          ...base,
          margin: 0,
          ...customStyles?.singleValue
        }),
        input: base => ({
          ...base,
          padding: 0,
          margin: 0
        }),
        indicatorSeparator: base => ({
          ...base,
          display: 'none',
          ...customStyles?.indicatorSeparator
        }),
        valueContainer: base => ({
          ...base,
          padding: 0
        }),
        option: (base, state) => ({
          ...base,
          color: theme.DF_COLOR.GRAY900,
          whiteSpace: 'pre-wrap',
          backgroundColor: state.isSelected
            ? theme.DF_COLOR.GRAY20
            : theme.DF_COLOR.WHITE,
          ':hover': {
            backgroundColor: theme.DF_COLOR.GRAY20
          },
          ':active': {
            backgroundColor: theme.DF_COLOR.GRAY50
          }
        })
      }}
      components={{
        IndicatorsContainer: state => {
          return state.selectProps.menuIsOpen ? (
            <MaterialIcon
              name={'expand_less'}
              size={16}
              color={theme.DF_COLOR.GRAY900}
            />
          ) : (
            <MaterialIcon
              name={'expand_more'}
              size={16}
              color={theme.DF_COLOR.GRAY900}
            />
          );
        }
      }}
    />
  );
};

export default SelectBox;
